import CroustilleElement from '../lib/CroustilleElement'
import Modal from '../lib/Modal'

class Menu extends Modal(CroustilleElement) {
  constructor() {
    super('menu')
  }

  get submenus() {
    return this.child('navigation').querySelectorAll(
      '.menu-item-has-children .menu-item-has-children'
    )
  }

  submenuLink(item) {
    return item.querySelector(':scope > a')
  }

  submenuItem(item) {
    return item.querySelector(':scope > .sub-menu')
  }

  toggleSubmenu(e) {
    e.stopPropagation()
    e.preventDefault()

    if (e.currentTarget.parentElement.dataset.state === 'open') {
      this.submenus.forEach(
        submenu => (submenu.parentElement.dataset.state = 'close')
      )
      e.currentTarget.parentElement.dataset.state = 'close'
    } else {
      this.submenus.forEach(
        submenu => (submenu.parentElement.dataset.state = 'close')
      )
      e.currentTarget.parentElement.dataset.state = 'open'
    }
  }

  init() {
    super.init()

    this.toggleSubmenu = this.toggleSubmenu.bind(this)

    this.submenus.forEach(submenu =>
      this.submenuLink(submenu).addEventListener('click', this.toggleSubmenu)
    )
  }

  destroy() {
    this.submenus.forEach(submenu =>
      this.submenuLink(submenu).removeEventListener('click', this.toggleSubmenu)
    )

    super.destroy()
  }
}

export default Menu
